import { render, staticRenderFns } from "./AddDocuments.vue?vue&type=template&id=f693b26a&scoped=true&"
import script from "./AddDocuments.vue?vue&type=script&lang=js&"
export * from "./AddDocuments.vue?vue&type=script&lang=js&"
import style0 from "./AddDocuments.vue?vue&type=style&index=0&id=f693b26a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f693b26a",
  null
  
)

export default component.exports